<ng-container *transloco="let t">
    @if (!showMessageHtml) {
    <section>
        <h1>{{ t("auth.age.header") }}</h1>
        <div
            [innerHTML]="$safeNavigationMigration(client?.signUpHowOldHtml)"
        ></div>
        @if (client?.signUpHowOldButton1Text) {
        <button
            mat-raised-button
            color="primary"
            (click)="ageRangeChosen(1)"
            id="age-range-1"
        >
            <span class="button-text">
                <span class="inner-text">
                    {{ client?.signUpHowOldButton1Text }}
                </span>
                <mat-icon>arrow_forward</mat-icon>
            </span>
        </button>
        } @if (client?.signUpHowOldButton2Text) {
        <button
            mat-raised-button
            color="primary"
            (click)="ageRangeChosen(2)"
            id="age-range-2"
        >
            <span class="button-text">
                <span class="inner-text">
                    {{ client?.signUpHowOldButton2Text }}
                </span>
                <mat-icon>arrow_forward</mat-icon>
            </span>
        </button>
        } @if (client?.signUpHowOldButton3Text) {
        <button
            mat-raised-button
            color="primary"
            (click)="ageRangeChosen(3)"
            id="age-range-3"
        >
            <span class="button-text">
                <span class="inner-text">
                    {{ client?.signUpHowOldButton3Text }}
                </span>
                <mat-icon>arrow_forward</mat-icon>
            </span>
        </button>
        }
        <button mat-button (click)="goBack()">
            <mat-icon color="accent">arrow_back</mat-icon>
            {{ t("shared.go-back") | uppercase }}
        </button>
    </section>
    } @else {
    <h1>{{ t("auth.age.header") }}</h1>
    <div [innerHTML]="messageHtml"></div>
    <div class="actions">
        <button type="button" mat-button (click)="goBackPrevious()">
            <mat-icon color="accent">arrow_back</mat-icon>
            {{ t("shared.go-back") | uppercase }}
        </button>
        <button
            type="submit"
            mat-raised-button
            color="accent"
            (click)="continue()"
        >
            {{ t("shared.continue") | uppercase }}
        </button>
    </div>
    }
</ng-container>
